import React, {useState} from "react";
import Box from "@mui/material/Box";
import {ClickAwayListener} from "@mui/material";
import {menuItems} from "../../../config/menuItems.ts";
import Navbar from "../Navbar/navbar.tsx";
import Sidebar from "../Sidebar/sidebar.tsx";

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({children}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const handleClickAway = () => {
        if (sidebarOpen) {
            setSidebarOpen(false);
        }
    };

    return (
        <Box sx={{display: "flex", backgroundColor: "#F1F5F7",}}>
            <ClickAwayListener onClickAway={handleClickAway}>
                <Box>
                    <Navbar toggleSidebar={toggleSidebar}/>
                    <Sidebar
                        isOpen={sidebarOpen}
                        menuItems={menuItems}
                        setSidebarOpen={setSidebarOpen}
                    />
                </Box>
            </ClickAwayListener>
            <Box
                sx={{
                    flexGrow: 1,
                    backgroundColor: "#F1F5F7",
                    transition: "margin 0.3s",
                    paddingTop: "4.5rem",
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
export default Layout;
